<template>
    <el-dialog title="文件预览" :visible.sync="txtShow" width="50%" append-to-body center v-if="txtShow" @close="$emit('closeModel')">
        <p alt="" class="view_img">{{ txtContent }}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="$emit('closeModel')">关闭</el-button>
        </div>  
    </el-dialog>
</template>
<script>
export default {
    props:{
        txtShow:{
            require: true,
            default:false
        },
        txtContent:{
            require:true,
            default:""
        }
    }
}
</script>

<style lang="scss" scoped>
    .view_img{
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }

</style>